const isOpenRadio = state => state.isOpenRadio
const isOpenSelect = state => state.isOpenSelect
const startDate = state => state.startDate
const endDate = state => state.endDate
const month = state => state.month

const selectedYear = state => state.selectedYear
const selectedMonth = state => state.selectedMonth
const yearArr = state => state.yearArr


export default {
  isOpenRadio,
  isOpenSelect,
  startDate,
  endDate,
  month,
  yearArr,
  selectedYear,
  selectedMonth
}
